import { FiX } from "react-icons/fi";
import { CharacterAssetsEditor } from "@/components/CharacterAssetsEditor";

export default function CharacterAssetsModal({ onClose, characters = [], assets = [], onSaved }) {
    const count = assets.length
    return (
        <div id={`${CharacterAssetsModal.name}`}
            className='w-full h-full max-h-[500px] max-w-[400px] flex flex-col bg-background rounded-lg border'>
            <div className='flex justify-between py-2 px-4 items-center'>
                <span className='text-white text-lg font-bold'>Assign Characters</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}>
                    <FiX className='w-6 h-6' />
                </div>
            </div>
            <div className='flex-1 overflow-hidden p-4 flex flex-col'>
                <div className='mb-3 text-[11px] text-secondary-foreground'>
                    {`Update ${count} asset${count === 1 ? '' : 's'}`}
                </div>
                <CharacterAssetsEditor
                    characters={characters}
                    assets={assets}
                    onSaved={() => { onSaved?.(); onClose(true) }}
                    onCancel={() => onClose(null)}
                />
            </div>
        </div>
    )
}
